module.exports = __webpack_public_path__ + "static/img/store-banner-circle.a671f4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgstore/store-banner-circle.png
// module id = 95
// module chunks = 1